


















import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { warningNotificationWrapper } from '../../../../../../../../../../../../logic/helpers/NotificationService'
import {
  ErrorChannelInfo,
  SuccessChannelInfo,
} from '../../../../../../../../../../../../models/CheckChannels/CheckChannels'
import FieldTitle from '../../../../../../../../../../../Pi/components/FieldTitle.vue'
import PiDropdownInput from '../../../../../../../../../../../PiDropdownInput.vue'
import CustomEditor from '../../../../../../../../Editor/CustomEditor'
import { ActionNodeProps } from '../../../../../logic/types'

@Component({
  components: {
    FieldTitle,
    PiDropdownInput
  }
})
export default class NotifyGroupActionSetChannelField extends Vue {

  @Prop() editor!: CustomEditor

  @Prop() targetOptions!: ActionNodeProps['targetOptions']

  @Prop() prefix!: string

  isLoading = false

  checkChannelHandler(channelData: string): void {
    if (channelData) {
      this.isLoading = true
      this.editor.getChannelsInfo([ channelData ])
        .then(({ data }) => {
          const channelInfo = data[0]

          if (channelInfo instanceof SuccessChannelInfo) {
            this.setChannel(channelInfo.info.id)
          }

          if (channelInfo instanceof ErrorChannelInfo) {
            this.setErrorChannel(channelInfo.value)
          }
        })
        .finally(() => this.isLoading = false)
        .catch(() => this.isLoading = false)
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('fill_data_alert').toString())
    }
  }

  @Emit()
  setChannel(id: number): number {
    return id
  }

  @Emit()
  setErrorChannel(value: string): string {
    return value
  }
}
